/** Dispatch on `window` to open the launcher from anywhere (the app shell listens). */
export const OPEN_PALETTE_EVENT = 'af:open-palette';
/** Open the launcher, optionally prefilled (e.g. `@ada ` for "Ask an agent", `>` for commands). */
export const openPalette = (initial?: string) =>
  window.dispatchEvent(new CustomEvent<string | undefined>(OPEN_PALETTE_EVENT, { detail: initial }));

/** Opens the kill-switch confirmation (typed HALT) from the launcher. */
export const OPEN_HALT_EVENT = 'af:open-halt';
export const openHalt = () => window.dispatchEvent(new Event(OPEN_HALT_EVENT));
